module.exports = __webpack_public_path__ + "static/media/150-rubles.0fa8cb3d.svg";